var styleDataHash = "08687c9f";
const injectCss = () => {
  var css = `/*! rtl:begin:ignore */.wfrAK{background:rgba(0,0,0,.5);height:100%;position:relative;width:100%}.Cv8U-{animation:lz8JY 1.7s ease infinite,Vk2ZP 1.7s ease infinite;border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1em;left:0;margin:auto;position:absolute;right:0;top:0;width:1em}.Cv8U-.gxtyY{font-size:40px}.Cv8U-.vLuTK{font-size:20px}.y7KLn{border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1.5em;left:0;margin:auto;position:absolute;right:0;text-align:center;top:0;width:3em}.y7KLn.gxtyY{font-size:16px}.y7KLn.vLuTK{font-size:12px}.cLsyq{height:100%;width:100%}@keyframes Vk2ZP{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes lz8JY{0%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}5%,95%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}10%,59%{box-shadow:0 -.83em 0 -.4em,-.087em -.825em 0 -.42em,-.173em -.812em 0 -.44em,-.256em -.789em 0 -.46em,-.297em -.775em 0 -.477em}20%{box-shadow:0 -.83em 0 -.4em,-.338em -.758em 0 -.42em,-.555em -.617em 0 -.44em,-.671em -.488em 0 -.46em,-.749em -.34em 0 -.477em}38%{box-shadow:0 -.83em 0 -.4em,-.377em -.74em 0 -.42em,-.645em -.522em 0 -.44em,-.775em -.297em 0 -.46em,-.82em -.09em 0 -.477em}to{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}}
/*! rtl:end:ignore */`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var loaders_rtlignore_default = {
  "loaderOverlay": "wfrAK",
  "loader": "Cv8U-",
  "load6": "lz8JY",
  "spinner": "Vk2ZP",
  "medium": "gxtyY",
  "mini": "vLuTK",
  "progress": "y7KLn",
  "preview_img": "cLsyq"
};
export {
  loaders_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=loaders.rtlignore-scss.js.map
